import { TranslatedComponent, translation } from '@hh.ru/front-static-app';

import { NotificationKind } from 'src/components/Notifications/types';

const TrlKeys = {
    message: 'beta.employer.statistics.errors.backendUnavailable',
};

const BetaStatisticsBackendUnavailableError: TranslatedComponent = ({ trls }) => <>{trls[TrlKeys.message]}</>;

export const betaStatisticsBackendUnavailable = {
    Element: translation(BetaStatisticsBackendUnavailableError),
    kind: NotificationKind.Error,
    autoClose: true,
    dataQa: 'beta-statistics-backend-unavailable-error',
};

export const BETA_STATISTICS_BACKEND_UNAVAILABLE = 'BETA_STATISTICS_BACKEND_UNAVAILABLE';
